import React from 'react';
import { string } from 'prop-types';
import SvgIcon from '@mui/material/SvgIcon';

const VideoPlayerButtonIcon = props => {
  const { fill, color } = props;

  return (
    <SvgIcon
      style={{ fill: fill || color }}
      viewBox="0 0 50 50"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1019_20637)">
        <path
          d="M15.0591 36.8891C12.8209 36.8806 11.0085 35.0748 11 32.8445V13.0554C10.9963 11.6508 11.7241 10.3449 12.9226 9.60562C14.1211 8.86634 15.6187 8.79954 16.8787 9.42916L36.7388 19.316C38.1235 19.9976 39 21.4032 39 22.9422C39 24.4811 38.1235 25.8867 36.7388 26.5684L16.8787 36.4707C16.3131 36.7492 15.69 36.8925 15.0591 36.8891Z"
          fill="#2386E7"
        />
        <path
          d="M15.0591 36.8891C12.8209 36.8806 11.0085 35.0748 11 32.8445V13.0554C10.9963 11.6508 11.7241 10.3449 12.9226 9.60562C14.1211 8.86634 15.6187 8.79954 16.8787 9.42916L36.7388 19.316C38.1235 19.9976 39 21.4032 39 22.9422C39 24.4811 38.1235 25.8867 36.7388 26.5684L16.8787 36.4707C16.3131 36.7492 15.69 36.8925 15.0591 36.8891Z"
          stroke="white"
          stroke-width="2"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1019_20637"
          x="0"
          y="0"
          width="50"
          height="49.8892"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1019_20637"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1019_20637"
            result="shape"
          />
        </filter>
      </defs>
    </SvgIcon>
  );
};

VideoPlayerButtonIcon.propTypes = {
  fill: string,
  color: string,
};

VideoPlayerButtonIcon.defaultProps = {
  fill: undefined,
  color: undefined,
};

export default VideoPlayerButtonIcon;
